import { useApi } from "../../../swr/useApi";
import { api } from "../../api_client";
import type { ProductAttributeValueDto } from "../../../api";

/**
 * Returns CPU attribute values (e.g. Intel Core i7, AMD Ryzen 7) from
 * `/product-cpus`. See useProductRams for why this bypasses the typed SDK.
 */
export function useProductCpus() {
  return useApi<ProductAttributeValueDto[]>("product-cpus", async () =>
    api.get<ProductAttributeValueDto[]>("/api/v1/product-cpus"),
  );
}
